// import React, { useState } from 'react';
// import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
// import { useHistory } from 'react-router-dom';
// import { Collapse } from 'react-bootstrap';
// // import './Layout.css'; // Import your layout styles

// const Layout = () => {
//   const [selected, setSelected] = useState("dashboard");
//   const history = useHistory();
//   const [isUsermanagementOpen, setIsUsermanagementOpen] = useState(false);

//   const handleSelect = (selectedItem) => {
//     setSelected(selectedItem);
//     switch (selectedItem) {
//         case 'dashboard':
//             history.push('/home');
//             break;
//         case 'expense':
//             // Navigate to the home page
//             history.push('/cate');
//             break;
//         case 'credential':
//             // Navigate to the payment credential page
//             history.push('/Adminsupplier-master');
//             break;
//         case 'location':
//             // Navigate to the payment location page
//               history.push('/RawMaterial-master');
//               break;
//         case 'subscription':
//             history.push('/expense-log');
//             break;
//         case 'paymode':
//             history.push('/paymode-status-master');
//             break;
//         case 'credituser':
//             history.push('/creditUser');
//             break;
//         case 'createemp':
//             history.push('/employee-master');
//             break;
//         case 'createrol':
//             history.push('/role-master');
//             break;
//         default:
//             break;
//     }
// };


//   return (
//     <div className="layout">
//       <SideNav onSelect={handleSelect} style={{ backgroundColor: "#000" }} className="sidebar">
//         <SideNav.Toggle />
//         <SideNav.Nav>
//         <NavItem eventKey="dashboard">
//                     <NavIcon>
//                         <i className="bi bi-house" style={{ fontSize: '1.50em' }} />
//                     </NavIcon>
//                     <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                         DASHBOARD
//                     </NavText>
//                 </NavItem>
//         <NavItem eventKey="expense">
//             <NavIcon>
//                 <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '1.10em',fontFamily:"serif",fontWeight:"bolder" }}>
//               CATEGORY MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="credential">
//             <NavIcon>
//                 <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '1.05em',fontFamily:"serif",fontWeight:"bolder" }}>
//                 SUPPLIER MASTER
//             </NavText>
//             {/* <NavItem eventKey="charts/linechart">
//                 <NavText>
//                     Line Chart
//                 </NavText>
//             </NavItem>
//             <NavItem eventKey="charts/barchart">
//                 <NavText>
//                     Bar Chart
//                 </NavText>
//             </NavItem> */}
//         </NavItem>
//         <NavItem eventKey="location">
//             <NavIcon>
//             <i class="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               RAW MATERIAL MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="subscription">
//             <NavIcon>
//             <i class="bi bi-collection-play" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               EXPENSE LOG
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="paymode">
//             <NavIcon>
//             <i class="bi bi-credit-card" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               PAYMODE MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="credituser">
//             <NavIcon>
//             <i class="bi bi-credit-card" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               CREDIT USERS
//             </NavText>
//         </NavItem>
//         <NavItem onClick={() => setIsUsermanagementOpen(!isUsermanagementOpen)}>
//             <NavIcon>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               User Management
//             </NavText>
//           </NavItem>

//           <Collapse in={isUsermanagementOpen}>
//             <div>
//               <NavItem eventKey="createemp">
//                 <NavIcon>
//                   <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} />
//                 </NavIcon>
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CREATE EMPLOYEE
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="createrol">
//                 <NavIcon>
//                   <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
//                 </NavIcon>
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CREATE ROLE
//                 </NavText>
//               </NavItem>
//               </div>
//               </Collapse>
//         </SideNav.Nav>
//       </SideNav>
//       <div className="content">
//         {/* Main content goes here */}
//         {/* Add other components or content here */}
//       </div>
//     </div>
//   );
// };

// export default Layout;

// import React, { useState } from 'react';
// import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
// import { useHistory } from 'react-router-dom';
// import './Sidebar.css';
// // import './Layout.css'; // Optional: Your layout styles

// const AppSidebar = () => {
//   const [selected, setSelected] = useState("dashboard");
//   const [isUsermanagementOpen, setIsUsermanagementOpen] = useState(false);
//   const [isCategoryManagement, setIsCategoryManagement] = useState(false);
//   const [isCreditUser, setIsCreditUser] = useState(false);
//   const [isOpenSlot, setIsOpenSlot] = useState(false);
//   const [isOrderManage, setIsOrderManage] = useState(false);
//   const history = useHistory();
//   const [isMastersOpen, setIsMasterOpen] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isOpenReport, setIsOpenReport] = useState(false);

//   const handleSelect = (selectedItem) => {
//     setSelected(selectedItem);
//     switch (selectedItem) {
//       case 'dashboard':
//         history.push('/home');
//         break;
//       case 'credential':
//         history.push('/Adminsupplier-master');
//         break;
//       case 'location':
//         history.push('/RawMaterial-master');
//         break;
//       case 'subscription':
//         history.push('/expense-log');
//         break;
//       case 'paymode':
//         history.push('/paymode-status-master');
//         break;
//       case 'credituser':
//         history.push('/creditUser');
//         break;
//       case 'createemp':
//         history.push('/Adminemployee-master');
//         break;
//       case 'createrol':
//         history.push('/create-role');
//         break;
//       case 'createcate':
//         history.push('/create-category');
//         break;
//       case 'createsub':
//         history.push('/create-subcategory');
//         break;
//       case 'foodmanage':
//         history.push('/create-food');
//         break;
//       case 'createslot':
//         history.push('/slot-creation-master');
//         break;
//       case 'blockslot':
//         history.push('/create-blocking-slot');
//         break;
//       case 'creditorder':
//         history.push('/order-list');
//         break;
//       case 'paymenthis':
//         history.push('/payment-report');
//         break;
//       case 'refund':
//         history.push('/Refund');
//         break;
//       case 'neworder':
//         history.push('/new-order');
//         break;
//       case 'upcomingorder':
//         history.push('/upcoming-order');
//         break;
//       case 'cancelorder':
//         history.push('/cancelled-order');
//         break;
//       case 'pastorder':
//         history.push('/past-order');
//         break;
//       case 'createcredit':
//           history.push('/creditUser');
//           break;
//       case 'paymentReport':
//           history.push('/admin-payment-report');
//           break;
//       case 'settlements':
//           history.push('/new-settlement');
//           break;
//       case 'neworderreport':
//           // history.push('/new-order-report');
//           history.push('/upcoming-order-report');
//           break;
//       case 'upcomingorderreport':
//           history.push('/upcoming-order-report');
//           break;
//       case 'cancelorderreport':
//           history.push('/cancelled-order-report');
//           break;
//       case 'completedorderreport':
//           history.push('/completed-order-report');
//           break;
//       case 'deliveryperson':
//           history.push('/delivery-person');
//           break;
//       case 'deliverychart':
//           history.push('/delivery-chart');
//           break;
//       case 'settings':
//           history.push('/settings');
//           break;
//       case 'socialmedia':
//           history.push('/social-media');
//           break;
//       case 'admaster':
//           history.push('/ad-master');
//           break;
//       case 'bgimgmaster':
//           history.push('/bacgroountimg-master');
//           break;
//       default:
//         break;
//     }
//   };

  
//   const handleToggleSidebar = () => {
//     // Toggle sidebar visibility
//     setIsSidebarOpen(!isSidebarOpen);
//     // Set isCategoryManagement to false when toggling the sidebar
//     setIsCategoryManagement(false);
//     setIsCreditUser(false);
//     setIsOpenSlot(false);
//     setIsOrderManage(false);
//     setIsMasterOpen(false);
//     setIsUsermanagementOpen(false);
//   };


//   return (
//     <div className="layout">
//          <SideNav onSelect={handleSelect} style={{
//     position: "fixed",       // Fixes the position of the sidebar
//     top: 0,                  // Aligns it to the top of the viewport
//     left: 0,                 // Aligns it to the left of the viewport
//     height: "200vh",         // Ensures it spans the full viewport height
//     backgroundColor: "#000",
//     overflowY: "scroll",     // Enables vertical scrolling
//     maxHeight: "100vh",      // Keeps sidebar within viewport height  // Hides scrollbar in Firefox
//   }} className="sidebar"
//   expanded={isSidebarOpen} // Controls the sidebar open/close state
//   onToggle={handleToggleSidebar} >
//         <SideNav.Toggle onClick={handleToggleSidebar}  />
//         <SideNav.Nav style={{maxHeight:"200vh"}}>
//           <NavItem eventKey="dashboard">
//             <NavIcon>
//               <i className="bi bi-house" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               DASHBOARD
//             </NavText>
//           </NavItem>


//           <NavItem onClick={() => { setIsOrderManage(!isOrderManage); handleSelect(); }}>
//             <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               ORDER MANAGEMENT
//               <i className={`bi ${isOrderManage ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {/* Conditionally Rendered Sub-items with Indentation */}
//           {isOrderManage && (
//             <>
//              <NavItem eventKey="upcomingorder" onClick={() => handleSelect('upcomingorder')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  UPCOMING ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="neworder" onClick={() => handleSelect('neworder')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   ACTIVE ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="cancelorder" onClick={() => handleSelect('cancelorder')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  CANCELLED ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="pastorder" onClick={() => handleSelect('pastorder')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  PAST ORDER
//                 </NavText>
//               </NavItem>
//             </>
//           )} 


// <NavItem eventKey="deliveryperson">
//             <NavIcon>
//               <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               DELIVERY PERSON MANAGEMENT
//             </NavText>
//           </NavItem>


// <NavItem onClick={() => { setIsOpenReport(!isOpenReport); handleSelect(); }}>
//             <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               REPORT
//               <i className={`bi ${isOpenReport ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {/* Conditionally Rendered Sub-items with Indentation */}
//           {isOpenReport && (
//             <>
//               <NavItem eventKey="neworderreport" onClick={() => handleSelect('neworderreport')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   NEW ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="upcomingorderreport" onClick={() => handleSelect('upcomingorderreport')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  UPCOMING ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="cancelorderreport" onClick={() => handleSelect('cancelorderreport')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  CANCELLED ORDER
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="completedorderreport" onClick={() => handleSelect('completedorderreport')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  COMPLETED ORDER
//                 </NavText>
//               </NavItem>
//             </>
//           )} 

          
// <NavItem eventKey="deliverychart">
//             <NavIcon>
//               <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               DELIVERY CHART
//             </NavText>
//           </NavItem>


// <NavItem onClick={() => { setIsCreditUser(!isCreditUser); handleSelect(); }}>
//             <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               CREDIT USERS
//               <i className={`bi ${isCreditUser ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {isCreditUser && (
//             <>
//               <NavItem eventKey="creditorder" onClick={() => handleSelect('creditorder')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   ORDER LIST
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="paymenthis" onClick={() => handleSelect('paymenthis')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   PAYMENT HISTORY
//                 </NavText>
//               </NavItem>
//             </>
//           )}


//           <NavItem eventKey="refund">
//             <NavIcon>
//               <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               REFUND
//             </NavText>
//           </NavItem>

       
//            <NavItem eventKey="paymentReport">
//             <NavIcon>
//               <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               PAYMENT REPORT
//             </NavText>
//           </NavItem>

//           <NavItem eventKey="settlements">
//             <NavIcon>
//               <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               SETTLEMENTS
//             </NavText>
//           </NavItem>


//           <NavItem onClick={() => { setIsCategoryManagement(!isCategoryManagement); handleSelect(); }}>
//             <NavIcon onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               CATEGORY MANAGEMENT
//               <i className={`bi ${isCategoryManagement ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {isCategoryManagement && (
//             <>
//               <NavItem eventKey="createcate" onClick={() => handleSelect('createcate')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CATEGORY
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="createsub" onClick={() => handleSelect('createsub')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                    SUB CATEGORY
//                 </NavText>
//               </NavItem>
//             </>
//           )}

//          <NavItem eventKey="foodmanage">
//             <NavIcon>
//               <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               FOOD MANAGEMENT
//             </NavText>
//           </NavItem>

//          <NavItem onClick={() => { setIsMasterOpen(!isMastersOpen); handleSelect(); }}>
//         <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//           <i className="bi bi-cash-coin" style={{ fontSize: '1.2em' }} />
//         </NavIcon>
//         <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//           MASTERS
//           <i className={`bi ${isMastersOpen ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.8em' }} />
//         </NavText>
//       </NavItem>

//       {isMastersOpen && (
//         <>
//           <NavItem eventKey="credential" onClick={() => handleSelect('credential')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               SUPPLIER MASTER
//             </NavText>
//           </NavItem>
//           <NavItem eventKey="location" onClick={() => handleSelect('location')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               RAW MATERIAL MASTER
//             </NavText>
//           </NavItem>
//           <NavItem eventKey="paymode" onClick={() => handleSelect('paymode')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               PAYMODE MASTER
//             </NavText>
//           </NavItem>
//           <NavItem eventKey="createcredit" onClick={() => handleSelect('createcredit')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               CREDIT USER
//             </NavText>
//           </NavItem>
//           <NavItem eventKey="admaster" onClick={() => handleSelect('admaster')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               ADVERTISEMENT MASTER
//             </NavText>
//           </NavItem>
//           <NavItem eventKey="bgimgmaster" onClick={() => handleSelect('bgimgmaster')} style={{ paddingLeft: '30px' }}>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
//               BG IMAGE MASTER
//             </NavText>
//           </NavItem>
//         </>
//       )}

// {/* 
//           <NavItem eventKey="credential">
//             <NavIcon>
//               <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               SUPPLIER MASTER
//             </NavText>
//           </NavItem> */}

//           {/* <NavItem eventKey="location">
//             <NavIcon>
//               <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               RAW MATERIAL MASTER
//             </NavText>
//           </NavItem> */}

//           <NavItem eventKey="subscription">
//             <NavIcon>
//               <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               EXPENSE LOG
//             </NavText>
//           </NavItem>

//           {/* <NavItem eventKey="paymode">
//             <NavIcon>
//               <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               PAYMODE MASTER
//             </NavText>
//           </NavItem> */}

        
//           {/* User Management Dropdown */}
//           <NavItem onClick={() => { setIsUsermanagementOpen(!isUsermanagementOpen); handleSelect(); }}>
//             <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               USER MANAGEMENT
//               <i className={`bi ${isUsermanagementOpen ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {/* Conditionally Rendered Sub-items with Indentation */}
//           {isUsermanagementOpen && (
//             <>
//              <NavItem eventKey="createrol" onClick={() => handleSelect('createrol')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                  ROLE
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="createemp" onClick={() => handleSelect('createemp')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   EMPLOYEE
//                 </NavText>
//               </NavItem>
//             </>
//           )}


//          <NavItem onClick={() => { setIsOpenSlot(!isOpenSlot); handleSelect(); }}>
//             <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen)}}>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               SLOT MANAGEMENT
//               <i className={`bi ${isOpenSlot ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
//             </NavText>
//           </NavItem>

//           {/* Conditionally Rendered Sub-items with Indentation */}
//           {isOpenSlot && (
//             <>
//               <NavItem eventKey="createslot" onClick={() => handleSelect('createslot')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CREATE SLOT
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="blockslot" onClick={() => handleSelect('blockslot')} style={{ paddingLeft: '40px' }}>
//                 {/* <NavIcon>
//                   <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
//                 </NavIcon> */}
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   BLOCKING SLOT
//                 </NavText>
//               </NavItem>
//             </>
//           )} 

//           {/* <NavItem eventKey="settings">
//             <NavIcon>
//               <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               SETTINGS
//             </NavText>
//           </NavItem> */}

//           <NavItem eventKey="socialmedia">
//             <NavIcon>
//               <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               SOCIAL MEDIA
//             </NavText>
//           </NavItem>


//         </SideNav.Nav>
//       </SideNav>


//       <div className="content">
//         {/* Main content goes here */}
//       </div>
//     </div>
//   );
// };

// export default AppSidebar;






import React, { useState,useEffect } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { useHistory } from 'react-router-dom';
import './Sidebar.css';
// import './Layout.css'; // Optional: Your layout styles
import ReactTooltip from 'react-tooltip';
import bootstrapBundleMin from 'bootstrap/dist/js/bootstrap.bundle.min';
const AppSidebar = () => {
  const [selected, setSelected] = useState("");
  const [isUsermanagementOpen, setIsUsermanagementOpen] = useState(false);
  const [isCategoryManagement, setIsCategoryManagement] = useState(false);
  const [isCreditUser, setIsCreditUser] = useState(false);
  const [isOpenSlot, setIsOpenSlot] = useState(false);
  const [isOrderManage, setIsOrderManage] = useState(false);
  const history = useHistory();
  const [isMastersOpen, setIsMasterOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isOpenReport, setIsOpenReport] = useState(false);
  useEffect(() => {
    console.log("Selected NavItem:", selected);
  }, [selected]);
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    const tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
      return new bootstrapBundleMin.Tooltip(tooltipTriggerEl);
    });

    // Cleanup on component unmount
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);
  useEffect(() => {
    const savedKey = localStorage.getItem("selectedNavKey");
    if (savedKey) {
      setSelected(savedKey);
      console.log("localsaved"+savedKey);
    }
  }, []);
  const handleSelect = (selectedItem) => {
    getNavItemStyle(selectedItem)
    setSelected(selectedItem);
    switch (selectedItem) {
      case 'dashboard':
        history.push('/home');
        break;
      case 'credential':
        history.push('/Adminsupplier-master');
        break;
      case 'location':
        history.push('/RawMaterial-master');
        break;
      case 'subscription':
        history.push('/expense-log');
        break;
      case 'paymode':
        history.push('/paymode-status-master');
        break;
      case 'credituser':
        history.push('/creditUser');
        break;
      case 'createemp':
        history.push('/Adminemployee-master');
        break;
      case 'createrol':
        history.push('/create-role');
        break;
      case 'createcate':
        history.push('/create-category');
        break;
      case 'createsub':
        history.push('/create-subcategory');
        break;
      case 'foodmanage':
        history.push('/create-food');
        break;
      case 'createslot':
        history.push('/slot-creation-master');
        break;
      case 'blockslot':
        history.push('/create-blocking-slot');
        break;
      case 'creditorder':
        history.push('/order-list');
        break;
      case 'paymenthis':
        history.push('/payment-report');
        break;
      case 'refund':
        history.push('/Refund');
        break;
      case 'neworder':
        history.push('/new-order');
        break;
      case 'upcomingorder':
        history.push('/upcoming-order');
        break;
      case 'cancelorder':
        history.push('/cancelled-order');
        break;
      case 'pastorder':
        history.push('/past-order');
        break;
      case 'createcredit':
          history.push('/creditUser');
          break;
      case 'paymentReport':
          history.push('/admin-payment-report');
          break;
      case 'settlements':
          history.push('/new-settlement');
          break;
      case 'neworderreport':
          history.push('/new-order-report');
          break;
      case 'upcomingorderreport':
          history.push('/upcoming-order-report');
          break;
      case 'cancelorderreport':
          history.push('/cancelled-order-report');
          break;
      case 'completedorderreport':
          history.push('/completed-order-report');
          break;
      case 'deliveryperson':
          history.push('/delivery-person');
          break;
      case 'deliverychart':
          history.push('/delivery-chart');
          break;
      case 'settings':
          history.push('/settings');
          break;
      case 'socialmedia':
          history.push('/social-media');
          break;
      case 'admaster':
          history.push('/ad-master');
          break;
      case 'bgimgmaster':
          history.push('/bacgroountimg-master');
          break;
      case 'customers':
          history.push('/normal-customers');
          break;
      case 'slidermaster':
          history.push('/slider-master');
          break;
      case 'chargemaster':
          history.push('/charges-master');
          break;
      case 'taxmaster':
          history.push('/tax-master');
          break;
      case 'posbilling':
          history.push('/pos-billing');
          break;
      default:
        break;
    }
  };

  
  const handleToggleSidebar = () => {
    // Toggle sidebar visibility
    setIsSidebarOpen(!isSidebarOpen);
    // Set isCategoryManagement to false when toggling the sidebar
    setIsCategoryManagement(false);
    setIsCreditUser(false);
    setIsOpenSlot(false);
    setIsOrderManage(false);
    setIsMasterOpen(false);
    setIsUsermanagementOpen(false);
  };

  const getNavItemStyle = (itemKey) => ({
    backgroundColor: selected === itemKey ? "#333" : "transparent",
    color: selected === itemKey ? "#fff" : "#ccc",
    fontWeight: selected === itemKey ? "bold" : "normal",
    borderLeft: selected === itemKey ? "4px solid #007bff" : "none",
    paddingLeft: selected === itemKey ? "opx" : "0px",
    cursor: "pointer",
  });

  const handleNavClick = (itemKey) => {
    setSelected(itemKey);
    localStorage.setItem("selectedNavKey", itemKey);
    console.log('Saved nav'+itemKey)
  };

  return (
    <div className="layout">
         <SideNav onSelect={handleSelect} style={{
    position: "fixed",       // Fixes the position of the sidebar
    top: 0,                  // Aligns it to the top of the viewport
    left: 0,                 // Aligns it to the left of the viewport
    height: "200vh",         // Ensures it spans the full viewport height
    backgroundColor: "#000",
    overflowY: "scroll",     // Enables vertical scrolling
    maxHeight: "100vh",      // Keeps sidebar within viewport height  // Hides scrollbar in Firefox
  }} className="sidebar"
  expanded={isSidebarOpen} // Controls the sidebar open/close state
  onToggle={handleToggleSidebar} >
        <SideNav.Toggle onClick={handleToggleSidebar}  />
        <SideNav.Nav style={{maxHeight:"200vh"}}>
        <NavItem eventKey="dashboard" style={getNavItemStyle("dashboard")} onClick={() => handleNavClick("dashboard")} data-bs-toggle="tooltip"
  data-bs-title="Dashboard">
            <NavIcon>
              <i className="bi bi-house" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              DASHBOARD
            </NavText>
          </NavItem>


          <NavItem onClick={() => { setIsOrderManage(!isOrderManage); handleSelect("Order Management"); }}  data-bs-toggle="tooltip" style={getNavItemStyle("Order Management")} 
  data-bs-title="Order Management">
            <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Order Management")}}  >
              <i className="bi bi-folder-fill"  style={{ fontSize: '1.50em'}} onClick={() => handleNavClick("Order Management")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              ORDER MANAGEMENT
              <i className={`bi ${isOrderManage ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem>

          {/* Conditionally Rendered Sub-items with Indentation */}
          {isOrderManage && (
            <>
             <NavItem eventKey="upcomingorder" onClick={() =>handleSelect('upcomingorder')}  style={{ ...getNavItemStyle("upcomingorder"), paddingLeft: '40px' }}
 >
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText onClick={() => handleNavClick("upcomingorder")} style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 UPCOMING ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="neworder" onClick={() => handleSelect('neworder')} style={{ ...getNavItemStyle("neworder"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  ACTIVE ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="cancelorder" onClick={() => handleSelect('cancelorder')} style={{ ...getNavItemStyle("cancelorder"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 CANCELLED ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="pastorder" onClick={() => handleSelect('pastorder')} style={{ ...getNavItemStyle("pastorder"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 PAST ORDER
                </NavText>
              </NavItem>
            </>
          )} 


<NavItem eventKey="deliveryperson" onClick={() => handleNavClick("deliveryperson")} style={getNavItemStyle("deliveryperson")} data-bs-toggle="tooltip"
  data-bs-title="Delivery Person Management">
            <NavIcon onClick={() => handleNavClick("deliveryperson")}>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              DELIVERY PERSON MANAGEMENT
            </NavText>
          </NavItem>


<NavItem onClick={() => { setIsOpenReport(!isOpenReport); handleSelect('Report'); }} data-bs-toggle="tooltip" style={getNavItemStyle("Report")}
  data-bs-title="Report">
            <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Report")}}>
              <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} onClick={() => handleNavClick("Report")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              REPORT
              <i className={`bi ${isOpenReport ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem>

          {/* Conditionally Rendered Sub-items with Indentation */}
          {isOpenReport && (
            <>
              <NavItem eventKey="neworderreport" onClick={() => handleSelect('neworderreport')} style={{ ...getNavItemStyle("neworderreport"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  NEW ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="upcomingorderreport" onClick={() => handleSelect('upcomingorderreport')} style={{ ...getNavItemStyle("upcomingorderreport"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 UPCOMING ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="cancelorderreport" onClick={() => handleSelect('cancelorderreport')} style={{ ...getNavItemStyle("cancelorderreport"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 CANCELLED ORDER
                </NavText>
              </NavItem>
              <NavItem eventKey="completedorderreport" onClick={() => handleSelect('completedorderreport')} style={{ ...getNavItemStyle("completedorderreport"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 COMPLETED ORDER
                </NavText>
              </NavItem>
            </>
          )} 

          <NavItem eventKey="posbilling" onClick={() => handleNavClick("posbilling")} style={getNavItemStyle("posbilling")}  data-bs-toggle="tooltip"
  data-bs-title="POS">
            <NavIcon>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              POS
            </NavText>
          </NavItem>

          
<NavItem eventKey="deliverychart" onClick={() => handleNavClick("deliverychart")} style={getNavItemStyle("deliverychart")}  data-bs-toggle="tooltip"
  data-bs-title="Delivery Chart">
            <NavIcon>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              DELIVERY CHART
            </NavText>
          </NavItem>


<NavItem onClick={() => { setIsCreditUser(!isCreditUser); handleSelect('Credit Users'); }} data-bs-toggle="tooltip"  style={getNavItemStyle("Credit Users")}
  data-bs-title="Credit Users">
            <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Credit Users")}}>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} onClick={() => handleNavClick("Credit Users")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              CREDIT USERS
              <i className={`bi ${isCreditUser ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem>

          {isCreditUser && (
            <>
              <NavItem eventKey="creditorder" onClick={() => handleSelect('creditorder')} style={{ ...getNavItemStyle("creditorder"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  ORDER LIST
                </NavText>
              </NavItem>
              <NavItem eventKey="paymenthis" onClick={() => handleSelect('paymenthis')} style={{ ...getNavItemStyle("paymenthis"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  PAYMENT HISTORY
                </NavText>
              </NavItem>
            </>
          )}


          {/* <NavItem eventKey="refund" onClick={() => handleNavClick("refund")} style={getNavItemStyle("refund")} data-bs-toggle="tooltip"
  data-bs-title="Refund">
            <NavIcon>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              REFUND
            </NavText>
          </NavItem> */}

       
           <NavItem eventKey="paymentReport" onClick={() => handleNavClick("paymentReport")} style={getNavItemStyle("paymentReport")} data-bs-toggle="tooltip"
  data-bs-title="Payment Report">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              PAYMENT REPORT
            </NavText>
          </NavItem>

          <NavItem eventKey="settlements" onClick={() => handleNavClick("settlements")} style={getNavItemStyle("settlements")} data-bs-toggle="tooltip"
  data-bs-title="Settlements">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SETTLEMENTS
            </NavText>
          </NavItem>


          <NavItem onClick={() => { setIsCategoryManagement(!isCategoryManagement); handleSelect('Categroy Management'); }} data-bs-toggle="tooltip" style={getNavItemStyle("Categroy Management")}
  data-bs-title="Categroy Management">
            <NavIcon onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Categroy Management")}}>
              <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} onClick={() => handleNavClick("Categroy Management")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              CATEGORY MANAGEMENT
              <i className={`bi ${isCategoryManagement ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem>

          {isCategoryManagement && (
            <>
              <NavItem eventKey="createcate" onClick={() => handleSelect('createcate')} style={{ ...getNavItemStyle("createcate"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  CATEGORY
                </NavText>
              </NavItem>
              <NavItem eventKey="createsub" onClick={() => handleSelect('createsub')} style={{ ...getNavItemStyle("createsub"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                   SUB CATEGORY
                </NavText>
              </NavItem>
            </>
          )}

         <NavItem eventKey="foodmanage" onClick={() => handleNavClick("foodmanage")} style={getNavItemStyle("foodmanage")} data-bs-toggle="tooltip"
  data-bs-title="Food Management">
            <NavIcon >
              <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              FOOD MANAGEMENT
            </NavText>
          </NavItem>

         <NavItem onClick={() => { setIsMasterOpen(!isMastersOpen); handleSelect("Masters"); }} data-bs-toggle="tooltip" style={getNavItemStyle("Masters")}
  data-bs-title="Masters">
        <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Masters")}}>
          <i className="bi bi-cash-coin" style={{ fontSize: '1.2em' }} onClick={() => handleNavClick("Masters")}/>
        </NavIcon>
        <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
          MASTERS
          <i className={`bi ${isMastersOpen ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.8em' }} />
        </NavText>
      </NavItem>

      {isMastersOpen && (
        <>
          <NavItem eventKey="credential" onClick={() => handleSelect('credential')} style={{ ...getNavItemStyle("credential"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              SUPPLIER MASTER
            </NavText>
          </NavItem>
          <NavItem eventKey="location" onClick={() => handleSelect('location')} style={{ ...getNavItemStyle("location"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              RAW MATERIAL MASTER
            </NavText>
          </NavItem>
          <NavItem eventKey="paymode" onClick={() => handleSelect('paymode')} style={{ ...getNavItemStyle("paymode"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              PAYMODE MASTER
            </NavText>
          </NavItem>
          <NavItem eventKey="createcredit" onClick={() => handleSelect('createcredit')} style={{ ...getNavItemStyle("createcredit"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              CREDIT USER
            </NavText>
          </NavItem>
          <NavItem eventKey="admaster" onClick={() => handleSelect('admaster')} style={{ ...getNavItemStyle("admaster"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              ADVERTISEMENT MASTER
            </NavText>
          </NavItem>
          <NavItem eventKey="bgimgmaster" onClick={() => handleSelect('bgimgmaster')} style={{ ...getNavItemStyle("bgimgmaster"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              BG IMAGE MASTER
            </NavText>
          </NavItem>
          <NavItem eventKey="slidermaster" onClick={() => handleSelect('slidermaster')} style={{ ...getNavItemStyle("slidermaster"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              SLIDER MASTER
            </NavText>
          </NavItem>

          <NavItem eventKey="taxmaster" onClick={() => handleSelect('taxmaster')} style={{ ...getNavItemStyle("taxmaster"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
              TAX MASTER
            </NavText>
          </NavItem>

          <NavItem eventKey="chargemaster" onClick={() => handleSelect('chargemaster')} style={{ ...getNavItemStyle("chargemaster"), paddingLeft: '40px' }}>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '1px 0', margin: '0px' }}>
               CHARGE MASTER
            </NavText>
          </NavItem>
        </>
      )}

{/* 
          <NavItem eventKey="credential">
            <NavIcon>
              <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SUPPLIER MASTER
            </NavText>
          </NavItem> */}

          {/* <NavItem eventKey="location">
            <NavIcon>
              <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              RAW MATERIAL MASTER
            </NavText>
          </NavItem> */}

          <NavItem eventKey="subscription" onClick={() => handleNavClick("subscription")} style={getNavItemStyle("subscription")} data-bs-toggle="tooltip"
  data-bs-title="Expense Log">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              EXPENSE LOG
            </NavText>
          </NavItem>

          {/* <NavItem eventKey="paymode">
            <NavIcon>
              <i className="bi bi-credit-card" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              PAYMODE MASTER
            </NavText>
          </NavItem> */}

        
          {/* User Management Dropdown */}
          {/* <NavItem onClick={() => { setIsUsermanagementOpen(!isUsermanagementOpen); handleSelect('User Management'); }} data-bs-toggle="tooltip" style={getNavItemStyle("User Management")}
  data-bs-title="User Management">
            <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("User Management")}}>
              <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} onClick={() => handleNavClick("User Management")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              USER MANAGEMENT
              <i className={`bi ${isUsermanagementOpen ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem> */}

          {/* Conditionally Rendered Sub-items with Indentation */}
          {/* {isUsermanagementOpen && (
            <>
             <NavItem eventKey="createrol" onClick={() => handleSelect('createrol')} style={{ ...getNavItemStyle("createrol"), paddingLeft: '40px' }}>
               
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                 ROLE
                </NavText>
              </NavItem>
              <NavItem eventKey="createemp" onClick={() => handleSelect('createemp')} style={{ ...getNavItemStyle("createemp"), paddingLeft: '40px' }}>
              
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  EMPLOYEE
                </NavText>
              </NavItem>
            </>
          )} */}


         <NavItem onClick={() => { setIsOpenSlot(!isOpenSlot); handleSelect(); handleNavClick("Slot Management")}} data-bs-toggle="tooltip" style={getNavItemStyle("Slot Management")}
  data-bs-title="Slot Management">
            <NavIcon  onClick={ ()=>{setIsSidebarOpen(!isSidebarOpen);handleNavClick("Slot Management")}}>
              <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} onClick={() => handleNavClick("Slot Management")}/>
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SLOT MANAGEMENT
              <i className={`bi ${isOpenSlot ? 'bi-caret-down-fill' : 'bi-caret-right-fill'}`} style={{ marginLeft: '2px', fontSize: '0.9em' }} />
            </NavText>
          </NavItem>

          {/* Conditionally Rendered Sub-items with Indentation */}
          {isOpenSlot && (
            <>
              <NavItem eventKey="createslot" onClick={() => handleSelect('createslot')} style={{ ...getNavItemStyle("createslot"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-person-plus" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  CREATE SLOT
                </NavText>
              </NavItem>
              <NavItem eventKey="blockslot" onClick={() => handleSelect('blockslot')} style={{ ...getNavItemStyle("blockslot"), paddingLeft: '40px' }}>
                {/* <NavIcon>
                  <i className="bi bi-people-fill" style={{ fontSize: '1.50em' }} />
                </NavIcon> */}
                <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
                  BLOCKING SLOT
                </NavText>
              </NavItem>
            </>
          )} 

          {/* <NavItem eventKey="settings">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SETTINGS
            </NavText>
          </NavItem> */}

          <NavItem eventKey="socialmedia"  onClick={() => handleNavClick("socialmedia")} style={getNavItemStyle("socialmedia")} data-bs-toggle="tooltip"
  data-bs-title="Social Media">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SOCIAL MEDIA
            </NavText>
          </NavItem>



          <NavItem eventKey="customers"  onClick={() => handleNavClick("customers")} style={getNavItemStyle("customers")} data-bs-toggle="tooltip"
  data-bs-title="customers">
            <NavIcon>
              <i className="bi bi-person-lines-fill" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              CUSTOMERS
            </NavText>
          </NavItem>


        </SideNav.Nav>
      </SideNav>


      <div className="content">
        {/* Main content goes here */}
      </div>
    </div>
  );
};

export default AppSidebar;

